export function defaultSellerName(companyName: string): string {
  const name = companyName.trim();
  return name ? `Ventas ${name}` : 'Ventas';
}

/** "" o 0 = sin mínimo (todos pasan). Acepta "1.000" y "1000". */
export function parseSizeMin(raw: string): number | null {
  const digits = raw.replace(/[.\s]/g, '').replace(',', '.');
  if (!digits) return null;
  const value = Number(digits);
  return Number.isFinite(value) && value > 0 ? value : null;
}

/** Las primeras preguntas que va a hacer el bot, en el orden del embudo generado. */
export function previewQuestions(productName: string, sizeQuestion: string): string[] {
  const product = productName.trim() || 'lo que vendés';
  // Mismo orden que el embudo generado: nombre (5), tamaño (10), necesidad (15).
  return [
    '¿Cómo te llamás? (nombre y apellido)',
    sizeQuestion.trim() || 'Tu pregunta de tamaño',
    `¿Qué te gustaría resolver con ${product}?`,
  ];
}
